
const digest = '18ec13f04fa931ce0d6134f9c99817e81f14e729520afced5adfbfbd43a248b8';
const classes = {"actions":"_actions_9f010_1"};
const css = `._actions_9f010_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  